var map = {
	"./-m-mine.svg": 9775,
	"./address.svg": 463,
	"./bug.svg": 1796,
	"./ces.svg": 4088,
	"./enterAccount.svg": 9615,
	"./funcUser.svg": 146,
	"./home.svg": 5702,
	"./info.svg": 9859,
	"./invoice.svg": 96,
	"./myAccount.svg": 9444,
	"./news.svg": 9434,
	"./notice.svg": 9721,
	"./order.svg": 6085,
	"./recommend.svg": 5553,
	"./user.svg": 1324,
	"./userInfo.svg": 1623
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2007;